import types from "../types/afaActionTypes";

export const initialState = {
	afaDetail: {
		afaId: "",
		id: "",
		afaName: "",
		afaFamily: "",
		afaType: "",
		status: "",
		appliesTo: "",
		effectiveDate: "",
		createdBy: "",
		createdTs: "",
		owner: "",
		description: "",
		organizationId: "",
		matterNumber: ""
	},
  organizationAfaData: {
    afas: [],
    count: 0,
  },
  matterAfaData: {
    afas: [],
    count: 0,
  }
};

const afaReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_INPUT_VALUE: {
      const { name, value } = action.payload;
      return {
        ...state,
        afaDetail: {
          ...state.afaDetail,
          [name]: value
        }
      }
    }
    case types.SET_AFA_DETAIL:
			return {
				...state,
				afaDetail: {
					...state.afaDetail,
					...action.payload,
				}
			}
    case types.SET_ORGANIZATION_AFA_DATA:
      return {
        ...state,
        organizationAfaData: action.payload,
      };
    case types.SET_MATTER_AFA_DATA:
      return {
        ...state,
        matterAfaData: action.payload,
      };
    case types.RESET_AFA_DETAIL:
      return {
        ...state,
        afaDetail: initialState.afaDetail
      }
		default:
			return state;
  }
}

export default afaReducer;
